import { Loading, Title } from "@components";
import OcdpAPI2 from "providers/OcdpAPI2";
import { useEffect, useState } from "react";
import { InputSearch } from "shared/components/InputSearch";
import { AudiencesTable } from "shared/containers/cdp/audiences/AudiencesTable";

export default function ArchivedAudiences() {
  const [audiences, setAudiences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const fetchData = async () => {
    const ocdp_api = new OcdpAPI2();

    let audiences = await ocdp_api.audiences();

    setAudiences(
      audiences.map((a) => ({
        id: a.id,
        name: a.name,
        type: a.type,
        status: a.status,
        brand_id: a.brand_id,
        brand: a.brand || { id: a.brand_id },
        unit_id: a.unit_id,
        unit: a.unit || { id: a.unit_id },
        schema: a.schema,
        filters: a.filters,
        boxes: a.boxes,
        links: a.links,
        execution_id: a.execution_id,
        qtd_customers: a.customers || 0,
        qtv_variables: a.schema?.length || 0,
        sort: a.extras?.sort,
        limit: a.extras?.limit,
      }))
    );

    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filteredAudiences = audiences.filter((c) => {
    return !!search
      ? c.name?.toLowerCase().includes(search.toLowerCase())
      : true;
  });

  if (loading) return <Loading fullContent />;

  return (
    <>
      <Title
        title="Públicos arquivados"
        backTo={{ url: "/cdp", name: "Base de dados" }}
      >
        <InputSearch
          placeholder="Buscar por..."
          onChange={(e) => setSearch(e.target.value)}
        />
      </Title>

      <AudiencesTable audiences={filteredAudiences} archived />
    </>
  );
}
